// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-default/index.css';
import locale from 'element-ui/lib/locale/lang/en';
import axios from 'axios';
import VueI18n from 'vue-i18n';
import App from './App';
import router from './router';
import messages from './lang';

Vue.use(VueI18n);
Vue.use(ElementUI, { locale });
Vue.prototype.$http = axios;

Vue.config.productionTip = false;

let userLang = navigator.language || navigator.userLanguage;
console.log(`userLang: ${userLang}`);
if (userLang === 'zh-CN') {
  userLang = 'cn';
} else {
  userLang = 'en';
}

Vue.prototype.$lang = userLang;

const i18n = new VueI18n({
  locale: userLang, // set locale
  messages, // set locale messages
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js